/* eslint-disable jsx-a11y/anchor-is-valid */

import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";

import FormController from "../../../FormController/FormController";
import FormTitle from "../../../FormTitle/FormTitle";
import PageLanding from "../../components/PageLanding";

const ByPriceLanding = () => {
  const history = useHistory();
  const { type } = useSelector((state) => state?.singleGroup);

  const byPriceBoxes = [
    {
      id: "valueGames",
      title: "Value Games",
      boxName: "Value Games",
      img: "by-price/image-affordable.jpg",
      extraText1:
        type === "single"
          ? "Tickets starting at $9"
          : "Group discounts starting at $9",
      extraText2: type === "single" ? "" : "",
      featured: true,
    },
    {
      id: "regularGames",
      title: "Regular Games",
      boxName: "Regular Games",
      img: "by-price/image-regular-games.jpg",
      extraText1:
        type === "single"
          ? "Tickets starting at $13"
          : "Group discounts starting at $12",
    },
    {
      id: "primeGames",
      title: "Prime Games",
      boxName: "Prime Games",
      img: "by-price/image-prime.jpg",
      extraText1:
        type === "single"
          ? "Tickets starting at $18"
          : "Group discounts starting at $16",
    },
    {
      id: "marqueeGames",
      title: "Marquee Games",
      boxName: "Marquee Games",
      img: "by-price/image-marquee.jpg",
      extraText1:
        type === "single"
          ? "Tickets starting at $26"
          : "Group discounts starting at $21",
    },
    // {
    //   id: "diamondGames",
    //   title: "Diamond Games",
    //   boxName: "Diamond Games",
    //   img: "by-price/image-diamond.jpg",
    //   extraText1: type === "single" ? "" : "",
    // },
  ];

  useEffect(() => {
    if (!type) history.push("/");
  }, [history, type]);
  //

  return (
    <div>
      <FormTitle title="Select Price Tier" />
      <p
        style={{
          fontFamily: "Gotham-Medium",
          fontStyle: "normal",
          fontWeight: 350,
          fontSize: "14px",
          lineHeight: "19px",
          textAlign: "center",
          color: "#000847",
          marginTop: "-20px",
        }}
      >
        *A $10 processing fee will be added to all orders at checkout
      </p>
      <PageLanding
        boxesArr={byPriceBoxes}
        goToPage={"by-price"}
        trackingTitle="Select Price Tier"
      />
      <FormController
        backTo="/ticket-single-group"
        startOver="/"
        showBack
        showStartOver
      />
    </div>
  );
};

export default ByPriceLanding;
